export const getSafeNumber = (n: number) =>
  n >= Number.MIN_SAFE_INTEGER && n <= Number.MAX_SAFE_INTEGER ? n : 0;
